import {field, identifier, LocalisableEntityData} from "@fedeltapointofsale/data-client";
import {EntityData} from "@fedeltapointofsale/data-client";

export class PositionData extends EntityData<PositionData> {
    @identifier positionId: number;
    @field name: string;
    @field description: string;
}
